import { PaywallModalsContext } from '#pplx/frontend/apps/ask/paywall-ui/context/PaywallModalsContext.js';
import { useContext } from 'react';
export const usePaywallModals = () => {
    const context = useContext(PaywallModalsContext);
    if (!context) {
        throw new Error('usePaywallModals must be used within a PaywallModalsProvider');
    }
    return context;
};
export const usePaywallModalsOptional = () => {
    return useContext(PaywallModalsContext);
};
//# sourceMappingURL=PaywallModalsContextSupport.js.map